
import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/productionProcess',
    meta: { title: '生产过程检查' },
    component: Layout,
    redirect: '/productionProcess/list',
    children: [
      {
        path: 'list',
        meta: { title: '生产过程检查', activeMenu: '/productionProcess' },
        component: () => import('@/views/productionProcess/ProductionProcess.vue')
      },
      {
        path: 'detail',
        meta: { title: '生产过程检查详情', activeMenu: '/productionProcess' },
        component: () => import('@/views/productionProcess/ProductionProcessDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑生产过程检查', activeMenu: '/productionProcess' },
        component: () => import('@/views/productionProcess/ProductionProcessAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增生产过程检查', activeMenu: '/productionProcess' },
        component: () => import('@/views/productionProcess/ProductionProcessAdd.vue')
      }

    ]
  }

]
